var map = {
	"./locale-provider/ar_EG.tsx": 996,
	"./locale-provider/bg_BG.tsx": 1000,
	"./locale-provider/ca_ES.tsx": 1004,
	"./locale-provider/cs_CZ.tsx": 1008,
	"./locale-provider/de_DE.tsx": 1012,
	"./locale-provider/el_GR.tsx": 1016,
	"./locale-provider/en_GB.tsx": 1020,
	"./locale-provider/en_US.tsx": 1024,
	"./locale-provider/es_ES.tsx": 1025,
	"./locale-provider/et_EE.tsx": 1029,
	"./locale-provider/fa_IR.tsx": 1033,
	"./locale-provider/fi_FI.tsx": 1037,
	"./locale-provider/fr_BE.tsx": 1041,
	"./locale-provider/fr_FR.tsx": 1045,
	"./locale-provider/is_IS.tsx": 1049,
	"./locale-provider/it_IT.tsx": 1053,
	"./locale-provider/ja_JP.tsx": 1057,
	"./locale-provider/ko_KR.tsx": 1061,
	"./locale-provider/ku_IQ.tsx": 1065,
	"./locale-provider/nb_NO.tsx": 1069,
	"./locale-provider/nl_BE.tsx": 1073,
	"./locale-provider/nl_NL.tsx": 1077,
	"./locale-provider/pl_PL.tsx": 1081,
	"./locale-provider/pt_BR.tsx": 1085,
	"./locale-provider/pt_PT.tsx": 1089,
	"./locale-provider/ru_RU.tsx": 1093,
	"./locale-provider/sk_SK.tsx": 1097,
	"./locale-provider/sr_RS.tsx": 1101,
	"./locale-provider/sv_SE.tsx": 1105,
	"./locale-provider/th_TH.tsx": 1109,
	"./locale-provider/tr_TR.tsx": 1113,
	"./locale-provider/uk_UA.tsx": 1115,
	"./locale-provider/vi_VN.tsx": 1119,
	"./locale-provider/zh_CN.tsx": 1123,
	"./locale-provider/zh_TW.tsx": 1126
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 995;


//////////////////
// WEBPACK FOOTER
// ./components ^\.\/locale-provider\/.+_.+\.tsx$
// module id = 995
// module chunks = 0